<template >
  <v-container fluid class="pa-0" style="margin-left: -27px !important; margin-top: -56px !important">
    <v-app class="pa-0">
      <v-main class="d-flex flex-wrap pa-0">
        <SkeletonLoader v-if="this.isMounted"/>
        <div class="d-flex flex-wrap">
          <v-row no-gutters >
            <v-col v-for="(graph, index) in this.GraphData" :key="index" :cols="graph.types === 'card' ? '6' : '12'" :md="graph.columns">
              <v-sheet v-if="graph.types == 'card'" class="ma-2 justify-space-between"> 
                <CardChart :title="graph.title" :total="graph.total" :icon="graph.icon"/>
              </v-sheet>
              <v-sheet v-else-if="graph.types == 'line'" class="ma-2">
                <LineChart :X="graph.x[0]" :Y="graph.y[0]" :title="graph.title"/>
              </v-sheet>
              <v-sheet v-else-if="graph.types == 'bar'" class="ma-2">
                <BarChart :X="graph.x[0]" :Y="graph.y[0]" :title="graph.title"/>
              </v-sheet>
              <v-sheet v-else class="ma-2">
                <DonutChart :X="graph.x[0]" :Y="graph.y[0]" :title="graph.title"/>
              </v-sheet>
            </v-col>
          </v-row>
        </div>
      </v-main>
    </v-app>
  </v-container>
</template>
<script>
import Vue from "vue";
import EntityService from '../../services/entityService';
import LineChart from '../../components/graph/line.vue';
import DonutChart from '../../components/graph/donut.vue';
import BarChart from '../../components/graph/bar.vue';
import CardChart from '../../components/graph/card.vue';
import SkeletonLoader from '../../components/skeletonLoaders/Dashboard.vue'

export default {
name: "Home",
data() {
  return {
    entityDashboard: new EntityService('Dashboard'),
    Dashboard: [],
    GraphTypes: [],
    GraphData: [],
    isMounted: true,
  };
},

components: {
  LineChart,
  BarChart,
  DonutChart,
  SkeletonLoader,
  CardChart,
},

methods: {

  async getDashboardId() {
    try {
      let response = await this.entityDashboard.getAll(1, 30, '', '', '');
      return response.data.data.data;
    } catch (error) {
      console.error("Error fetching dashboard IDs:", error);
      throw error;
    }
  },

  async getGraphsViews() {
    try {
      let idsParam = await this.getDashboardId();
      let results = [];

      for (let index = 0; index < idsParam.length; index++) {
        let response = await Vue.prototype.$http.get(`/Entity/Dashboard/search-items`, {
          params: {
            relationSchema: 'Graph',
            id: idsParam[index].id,
            page: 1,
            limit: 200,
            sortField: 'createAt',
            sortDesc: 'false'
          }
        });
        results.push(response.data.data.data);
      }
      return results;
    } catch (error) {
      console.error("Error fetching graph views:", error);
      throw error;
    }
  },

  async getGraphsData() {
  try {
    // Fetch initial graph data and flatten the array
    this.GraphData = await this.getGraphsViews();
    let flattenedGraphData = this.GraphData.flat();

    // Create an array of promises to fetch data for each graph
    let promises = flattenedGraphData.map(async (graph, index) => {
      try {
        // Common request data
        let requestData = {
          viewName: graph.viewName,
          params: [],
          page: 1,
          limit: 100
        };

        // Make the request based on the graph type
        let response = await Vue.prototype.$http.post('/View/run', requestData);

        // Update the graph data based on the response
        if (graph.types === 'card') {
          flattenedGraphData[index] = {
            ...graph,
            total: response.data.data.data[0]?.total || null
          };
        } else {
          flattenedGraphData[index] = {
            ...graph,
            x: response.data.data.data.map(item => item.x),
            y: response.data.data.data.map(item => item.y)
          };
        }

        // Return the updated graph data
        return flattenedGraphData[index];
      } catch (error) {
        // Handle errors by setting total to null
        flattenedGraphData[index] = { ...graph, total: null };
        return flattenedGraphData[index];
      }
    });

    // Wait for all promises to resolve
    await Promise.all(promises);

    // Return the updated flattened graph data
    return flattenedGraphData;
  } catch (error) {
    console.error("Error fetching graph cards:", error);
    throw error;
  }
},
},

async mounted() {
    this.Dashboard = await this.getDashboardId();
    this.GraphData = await this.getGraphsData();
    console.log('GRAPHDATA>>>>>',this.GraphData)
},

async updated(){
  this.isMounted = false
}
};
</script>

<style>
.navbar-scroll .v-navigation-drawer__content {
overflow-y: hidden;
}
.navbar-scroll:hover .v-navigation-drawer__content {
overflow-y: scroll;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0,0,0,.5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.31);
}

/* Tooltip container */
.tooltip {
position: relative;
display: inline-block;
border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
margin-top: 5px;
visibility: hidden;
width: 120px;
background-color: black;
color: #fff;
text-align: center;
padding: 5px 0;
border-radius: 6px;

/* Position the tooltip text - see examples below! */
position: absolute;
z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
visibility: visible;
transition: 5s;
}

.tooltip .tooltiptext {
top: -5px;
right: 105%;
}
/*
.v-menu__content--fixed {
  position: fixed;
  margin-top: 45px;
}*/

.cardContainer {
width: 100%;
}

.chartContainer {
display: flex;
flex-direction: row;
justify-content: space-between;
}
</style>
